// Full-width ASCII (U+FF01 - U+FF5E)
export const FULLWIDTH_ASCII_START = 0xff01;
